if (document.querySelector('.block-faq__items')) {
  document
    .querySelectorAll('.block-faq__items .faq-question')
    .forEach((question) => {
      question.addEventListener('click', () => {
        const item = question.parentElement;
        item.classList.toggle('active');
      });
    });
}
